import React, { useEffect, useState, useContext } from 'react';
import * as Icon from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ProductGrid from './ProductGrid';
import { ProductContext } from '../context/ProductContext';

const CategoryGrid = ({ section, qty }) => {
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [noSubcategoriesMessage, setNoSubcategoriesMessage] = useState('');

    const { subcategoryProducts, setSubcategoryProducts } = useContext(ProductContext);
    // Fetch categories on component mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const category = await getCategories();
                setCategories(category.categories);
            } catch (error) {
                console.error('Failed to fetch categories:', error);
            }
        };

        fetchCategories();
    }, []);

    // Handle category click to fetch subcategories and products
    const handleCategoryClick = async (categoryName) => {
        try {
            setSelectedCategory(categoryName); // Set the clicked category name
            const authtoken = localStorage.getItem('token');
            const authToken = `Bearer ${authtoken}`;

            // Fetch subcategories and their products using categoryName
            const response = await getSubCategoriesByCategoryName(authToken, categoryName);

            // Check if subcategories exist
            if (response?.subcategories?.length) {
                setSubCategories(response.subcategories);

                // Map products for all subcategories
                const allProducts = response.subcategories.flatMap(
                    (subcategory) => subcategory.products
                );

                setSubcategoryProducts(allProducts); // Store products in state for display
                setNoSubcategoriesMessage(''); // Clear message if subcategories are found
            } else {
                setSubCategories([]); // Reset subcategories state
                setSubcategoryProducts([]); // Reset products state
                setNoSubcategoriesMessage('No subcategories found for this category.'); // Set message if no subcategories
            }
        }
        catch (error) {
            console.error('Failed to fetch subcategories or products:', error);
        }
    };

    // Slice categories if qty is provided
    const displayedCategories = qty ? categories.slice(0, qty) : categories;

    // Function to chunk the subcategories array into groups of 4
    const chunkSubcategories = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    const subcategoryRows = chunkSubcategories(subcategories, 4);

    return (
        <div className="product-section container mx-auto my-5">
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-4 fw-bold">{section}</h4>
                <Link to="/categories" className="btn btn-sm btn-primary">
                    <Icon.Arrow90degRight color="white" size={20} />
                </Link>
            </div>

            <div className="categoriproduct">
                <ul className='after'>
                    {displayedCategories.map((category) => (
                        <li key={category.id} className="">
                            <button
                                className="card bordercolor shadow nav-link rounded-5"
                                onClick={() => handleCategoryClick(category.name)} // Use category name
                            >
                                {category.name}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            {noSubcategoriesMessage && <p>{noSubcategoriesMessage}</p>}

            {/* Display subcategories in rows of 4 */}
            {selectedCategory && subcategoryRows.length > 0 && (
                <div className="mt-4">
                    <h5>Subcategories</h5>
                </div>
            )}

            {/* Display products */}

            <ProductGrid products={subcategoryProducts} />


        </div>
    );
};

export default CategoryGrid;

export const getCategories = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}product/categories`);
        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
};

export const getSubCategoriesByCategoryName = async (token, categoryName) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}product/subcategories?categoryname=${categoryName}`,
            {
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data; // Expect subcategories with products
    } catch (error) {
        console.error('Error fetching subcategories by category name:', error);
    }
};




